// extracted by mini-css-extract-plugin
export var productImage = "_mf-1";
export var viewLink = "_mf-2";
export var wishlistItem = "_mf-0";